export const useStore = () => {
	let store = useState('store', () => {
		return {
			user: {
				_id: ''
			},
            drmJobs: [],
            dashJobs: [],
            hlsJobs: [],
            downloadJobs: [],
		}
	})
	return store.value
}
